import { useEffect, useState } from 'react';
export function useCopyWithDelay(initialState, delay) {
    const defaultTimeout = 3000; // 3 seconds
    const [isCopied, setIsCopied] = useState(initialState);
    useEffect(() => {
        const timeoutId = isCopied
            ? window.setTimeout(() => setIsCopied(false), delay || defaultTimeout)
            : undefined;
        return () => window.clearTimeout(timeoutId);
    }, [delay, isCopied]);
    return { isCopied, setIsCopied };
}
